// Helpers to tie the open problems of a vehicle (problemkendaraan) to the rows of an audit checklist card.
// A problem is matched to a row (detil) by keterangan + label_grup.

// status of a problem: 1 baru, 2 schedule, 3 solved, 4 ignore (see features/problem/utils/problemConstants.js)
export const isSolvedProblem = (problem) =>
  problem.status === 3 || !!problem.tanggal_selesai;

export const isIgnoredProblem = (problem) => problem.status === 4;

// A problem younger than this many days is a new problem, an older one is an old problem.
const NEW_PROBLEM_MAX_DAYS = 7;

// splits the problems into the new ones (younger than 7 days) and the old ones
export const splitProblemsByAge = (listProblemData) => {
  const newProblems = [];
  const oldProblems = [];
  (listProblemData || []).forEach((problem) => {
    const days = (new Date() - new Date(problem.tanggal)) / (1000 * 60 * 60 * 24);
    (days < NEW_PROBLEM_MAX_DAYS ? newProblems : oldProblems).push(problem);
  });
  return { newProblems, oldProblems };
};

// two gambar urls are the same file (the ?serial= only busts the browser cache)
export const isSameGambar = (a, b) => {
  if (!a || !b) return false;
  return a.split("?serial=")[0] === b.split("?serial=")[0];
};

// the open problem of a checklist row (detil), undefined when it has none
export const findProblem = (listProblemData, detil) => {
  if (!listProblemData || !detil) return undefined;
  return listProblemData.find(
    (problem) =>
      !isSolvedProblem(problem) &&
      problem.keterangan === detil.keterangan &&
      problem.label_grup === detil.label_grup
  );
};

// An unchecked row is a new problem when it has no open problem yet.
export const isNewProblem = ({ detil, listProblemData }) =>
  !findProblem(listProblemData, detil);

// the unchecked rows that are a new problem and still miss a note or a gambar
export const findMissingNewProblems = ({ detils, listProblemData }) =>
  detils.filter(
    (detil) =>
      detil.cek !== 1 &&
      isNewProblem({ detil, listProblemData }) &&
      (!detil.note || !detil.gambar)
  );
